import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Column } from 'components/shared/Layout';
import { emailReg } from 'utils/validators';
import { FormContainer, StyledLabel, StyledTextInput, ErrorMessage } from './VoucherDetails.styles';
import { useVoucherEditSettings } from './useVoucherEditSettings';

const CustomerDetailsTable = ({ firstName, lastName, register, errors = {} }) => {
  const editSettings = useVoucherEditSettings();

  return (
    <FormContainer>
      <Row columns={12}>
        <Column span={4}>
          <StyledLabel htmlFor="firstName">
            <FormattedMessage id="vouchers.firstName" />
          </StyledLabel>
          <StyledTextInput name="firstName" type="text" value={firstName} readOnly data-cy="voucher-first-name" />
        </Column>
        <Column span={4}>
          <StyledLabel htmlFor="lastName">
            <FormattedMessage id="vouchers.lastName" />
          </StyledLabel>
          <StyledTextInput name="lastName" type="text" value={lastName} readOnly data-cy="voucher-last-name" />
        </Column>
        <Column span={4}>
          <StyledLabel htmlFor="email">
            <FormattedMessage id="vouchers.email" />
          </StyledLabel>
          <StyledTextInput
            type="text"
            data-cy="voucher-customer-email"
            readOnly={!editSettings.fields.email}
            {...register('email', { required: true, pattern: emailReg })}
          />
          {errors.email && (
            <ErrorMessage>
              <FormattedMessage id="validators.invalidEmail" />
            </ErrorMessage>
          )}
        </Column>
      </Row>
    </FormContainer>
  );
};

CustomerDetailsTable.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  register: PropTypes.func,
  errors: PropTypes.shape({
    email: PropTypes.object
  })
};

export default CustomerDetailsTable;
